/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface ProductProfitabilityProductData
 */
export interface ProductProfitabilityProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    integrationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductProfitabilityProductData
     */
    productRemoteId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductProfitabilityProductData
     */
    amount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    purchasePrice?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    grossMargin?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    allocatedMarketingSpend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof ProductProfitabilityProductData
     */
    profitAfterMarketing?: MoneyOutput;
}

/**
 * Check if a given object implements the ProductProfitabilityProductData interface.
 */
export function instanceOfProductProfitabilityProductData(value: object): value is ProductProfitabilityProductData {
    return true;
}

export function ProductProfitabilityProductDataFromJSON(json: any): ProductProfitabilityProductData {
    return ProductProfitabilityProductDataFromJSONTyped(json, false);
}

export function ProductProfitabilityProductDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductProfitabilityProductData {
    if (json == null) {
        return json;
    }
    return {
        
        'productName': json['productName'] == null ? undefined : json['productName'],
        'integrationId': json['integrationId'] === undefined ? undefined : json['integrationId'] === null ? null : json['integrationId'],
        'productRemoteId': json['productRemoteId'] === undefined ? undefined : json['productRemoteId'] === null ? null : json['productRemoteId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'purchasePrice': json['purchasePrice'] == null ? undefined : MoneyOutputFromJSON(json['purchasePrice']),
        'grossMargin': json['grossMargin'] == null ? undefined : MoneyOutputFromJSON(json['grossMargin']),
        'allocatedMarketingSpend': json['allocatedMarketingSpend'] == null ? undefined : MoneyOutputFromJSON(json['allocatedMarketingSpend']),
        'profitAfterMarketing': json['profitAfterMarketing'] == null ? undefined : MoneyOutputFromJSON(json['profitAfterMarketing']),
    };
}

export function ProductProfitabilityProductDataToJSON(json: any): ProductProfitabilityProductData {
    return ProductProfitabilityProductDataToJSONTyped(json, false);
}

export function ProductProfitabilityProductDataToJSONTyped(value?: ProductProfitabilityProductData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productName': value['productName'],
        'integrationId': value['integrationId'],
        'productRemoteId': value['productRemoteId'],
        'amount': value['amount'],
        'turnover': MoneyOutputToJSON(value['turnover']),
        'purchasePrice': MoneyOutputToJSON(value['purchasePrice']),
        'grossMargin': MoneyOutputToJSON(value['grossMargin']),
        'allocatedMarketingSpend': MoneyOutputToJSON(value['allocatedMarketingSpend']),
        'profitAfterMarketing': MoneyOutputToJSON(value['profitAfterMarketing']),
    };
}

